import { render } from "./filter_menu.svg?vue&type=template&id=1f28037e?inline"
const script = {}
script.render = render

export default script